<template>
    <div id="viewer" class="fill flex-box nopadding bg-black" style="overflow: hidden;z-index: 999999" @mousewheel="onMouseWheel">
        <div class="flex-box-bd"></div>
        <img :src="img" style="max-height: 100vh;max-width: 100vw;width: unset" :style="{transform:'translate('+trs_x+'px,'+trs_y+'px) scale('+scale.scale_qty+')'}">
        <div class="flex-box-bd"></div>
    </div>
</template>

<script>
    export default {
        name: "myViewer",
        props:{
            img: {
                default:''
            },
        },
        data:function() {
            return {
                trs_x:0,
                trs_y:0,
                scale_qty:1,
                scale:{
                    scale_qty: 1
                }
            }
        },
        mounted:function(){
            var viewer = document.querySelector('#viewer');
            viewer.addEventListener('mousedown', (event) => {
                event.preventDefault();
                this.scale.moveable = true;

                // 第一个触摸点的坐标
                this.scale.pageX = event.pageX;
                this.scale.pageY = event.pageY;
            });
            viewer.addEventListener('mousemove', (event)=>{
                if (!this.scale.moveable) {
                    return;
                }
                event.preventDefault();
                this.drag(event);
            });
            viewer.addEventListener('mouseup', ()=>{
                this.scale.moveable = false;
                delete this.scale.pageX2;
                delete this.scale.pageY2;
            });
            viewer.addEventListener('mouseover', ()=>{
                this.scale.moveable = false;
                delete this.scale.pageX2;
                delete this.scale.pageY2;
            });
            viewer.addEventListener('mouseout', ()=>{
                this.scale.moveable = false;
                delete this.scale.pageX2;
                delete this.scale.pageY2;
            });
        },
        methods: {
            onMouseWheel:function (e){
                this.scale.scale_qty -= e.deltaY / 1000;
            },
            drag:function (event){
                this.trs_x = this.trs_x - (this.scale.pageX - event.pageX);
                this.trs_y = this.trs_y - (this.scale.pageY - event.pageY);
                this.scale.pageX = event.pageX;
                this.scale.pageY = event.pageY;
            }
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/myViewer.vue